/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="76.1" height="108.38" viewBox="0 0 76.1 108.38" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <defs>
    <mask id="b597f465-2069-4e1a-90dd-020d42e9f19e" x="0" y="0" width="76.1" height="108.38" maskUnits="userSpaceOnUse">
      <g transform="translate(-39 -25)">
        <polygon points="39 133.38 115.1 133.38 115.1 25 39 25 39 133.38" fill="#fff" fillRule="evenodd"/>
      </g>
    </mask>
  </defs>
  <g>
      <path d="M113.85,25a1.24,1.24,0,0,1,1.24,1.12V99.85a1.24,1.24,0,0,1-1.12,1.24H50.17a8.55,8.55,0,0,0-8.67,8.26v.31a8.69,8.69,0,0,0,8.41,8.41h13.7a1.25,1.25,0,0,1,.13,2.5H50.17A11.17,11.17,0,0,1,39,110l0-.37v-.21l0-.37v-.28a.5.5,0,0,1,0-.12V37.07A12.08,12.08,0,0,1,50.77,25h63.08Zm-1.25,2.5H51.07a9.58,9.58,0,0,0-9.57,9.3v65.84l.12-.15a11.23,11.23,0,0,1,8.26-3.89H112.6Z" transform="translate(-39 -25)" fill="#0e497b"/>
      <path d="M113.85,118.08a1.25,1.25,0,0,1,.13,2.49H77.51a1.25,1.25,0,0,1-.12-2.49h36.46Z" transform="translate(-39 -25)" fill="#0e497b"/>
      <path d="M109.67,108.34a1.25,1.25,0,0,1,.12,2.49H77.51a1.25,1.25,0,0,1-.12-2.49h32.28Z" transform="translate(-39 -25)" fill="#0e497b"/>
      <path d="M63.61,108.34a1.25,1.25,0,0,1,.13,2.49H49a1.25,1.25,0,0,1-.13-2.49H63.61Z" transform="translate(-39 -25)" fill="#0e497b"/>
      <path d="M51.07,25a1.26,1.26,0,0,1,1.25,1.12V99.85a1.25,1.25,0,0,1-2.49.13V26.25A1.25,1.25,0,0,1,51.07,25Z" transform="translate(-39 -25)" fill="#0e497b"/>
      <path d="M113,99a1.25,1.25,0,0,1,1.73,1.81,12.29,12.29,0,0,0-3.79,8.49v.44a12.56,12.56,0,0,0,3.55,8.49l.25.26a1.24,1.24,0,1,1-1.74,1.78,15.09,15.09,0,0,1-4.55-10.12v-.8l0-.49a14.77,14.77,0,0,1,4.27-9.59Z" transform="translate(-39 -25)" fill="#0e497b"/>
      <path d="M77.38,105.64H63.73a1.25,1.25,0,0,0-1.25,1.25v25.36a1.24,1.24,0,0,0,2,.88l6.09-4.5,6.08,4.5a1.25,1.25,0,0,0,2-1V106.89A1.25,1.25,0,0,0,77.38,105.64Zm-1.25,2.5v21.51l-4.83-3.58-.11-.08a1.26,1.26,0,0,0-1.38.08L65,129.65V108.14Z" transform="translate(-39 -25)" fill="#ffb81c"/>
      <g mask="url(#b597f465-2069-4e1a-90dd-020d42e9f19e)">
        <path d="M99.35,39.11H65.58a1.25,1.25,0,0,0-1.25,1.25V57.92a1.25,1.25,0,0,0,1.25,1.25H99.35a1.25,1.25,0,0,0,1.25-1.25V40.36A1.25,1.25,0,0,0,99.35,39.11Zm-1.25,2.5V56.67H66.83V41.61Z" transform="translate(-39 -25)" fill="#0e497b"/>
      </g>
    </g>
</svg>

    );
  }
}

Icon.displayName = 'BookWithBookmarkIcon';

export default Icon;
